import { apiDate } from "@/api/apicommon";
import { useI18n } from "vue-i18n"

/**
 * Based on shortRelativeDate from general.js
 * 
 * @returns The function to compute the relative date label.
 */
export const useComputeRelativeDate = (): (interestDateString: string, referenceDateString: string) => string => {
    const { t } = useI18n();

    return (interestDateString: string, referenceDateString: string) => {
        // Get dates
        const interestDate: Date | null = apiDate(interestDateString);
        const referenceDate: Date | null = apiDate(referenceDateString);
        const interestTime = interestDate ? interestDate.getTime() : 0;
        const referenceTime = referenceDate ? referenceDate.getTime() : 0;

        // Calculate the time difference in milliseconds
        const timeDifference = referenceTime - interestTime;
        
        // Calculate the number of years, months, weeks, and days
        const years = timeDifference / (365 * 24 * 60 * 60 * 1000);
        const months = timeDifference / (30 * 24 * 60 * 60 * 1000);
        const weeks = timeDifference / (7 * 24 * 60 * 60 * 1000);
        const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
        
        // Return
        if (timeDifference < 0 && days < -1) {  //if timeDifference is negative, but less than 1 day --> don't trigger
            return t('common.calendar.future');
        } else if (years > 1) {
            return  interestDate.getFullYear().toString();
        } else if (months > 1) {
            return t('common.calendar.months', { count: Math.floor(months) });
        } else if (weeks > 1) {
            return t('common.calendar.weeks', { count: Math.floor(weeks) });
        } else if (days < 1) {
            return  t('common.calendar.now');
        }

        return t('common.calendar.days', { count: days });
    }
}